export default class NumericValueUtils {
  static toAmountInEnglish(amount: number): string {
    const amountString = Number(amount).toLocaleString('en-US', { style: 'currency', currency: 'CAD', currencyDisplay: 'symbol' }).replace('CA$', '$');
    return amountString;
  }

  static toAmountInFrench(amount: number): string {
    const amountString =  Number(amount).toLocaleString('fr-CA', { style: 'currency', currency: 'CAD', currencyDisplay: 'symbol' });
    return amountString;
  }

  static toPercentageInEnglish(value: number): string {
    const convertValue = Number(value).toLocaleString(undefined, {maximumFractionDigits: 0});
    return convertValue + '%';
  }

  static toPercentageInFrench(value: number): string {
    const convertValue = Number(value).toLocaleString(undefined, {maximumFractionDigits: 0});
    return convertValue + ' %';
  }
}
